import * as React from 'react';
import { rgbToHex, useTheme } from '@mui/material/styles';
import * as colors from '@mui/material/colors';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Input from '@mui/material/Input';
import Radio from '@mui/material/Radio';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import Slider from '@mui/material/Slider';
import { capitalize } from '@mui/material/utils';
import { resetDocsColor, setDocsColors } from '@mui/internal-core-docs/branding';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { rgbToHex, useTheme }, "@mui/material/colors": colors, "@mui/material/Box": Box, "@mui/material/Grid": Grid, "@mui/material/Input": Input, "@mui/material/Radio": Radio, "@mui/material/Tooltip": Tooltip, "@mui/material/Typography": Typography, "@mui/material/Button": Button, "@mui/icons-material/Check": CheckIcon, "@mui/material/Slider": Slider, "@mui/material/utils": { capitalize }, "@mui/internal-core-docs/branding": { resetDocsColor, setDocsColors }, "prop-types": PropTypes, "@mui/material/AppBar": AppBar, "@mui/material/Toolbar": Toolbar, "@mui/material/Fab": Fab, "@mui/material/IconButton": IconButton, "@mui/icons-material/Menu": MenuIcon, "@mui/icons-material/Add": AddIcon } } });
export default ClientProvider;
